/**
 * Dropdown
 * ======================================
 * - on mobile open dropdown via click
 */

 const WIDGET = '.dropdown'
 const ACTIVECLASS = 'is-open'
 const IS_COARSE = matchMedia('(pointer:coarse)').matches

 export class Dropdown {
   constructor() {
     this.elements = document.querySelectorAll(WIDGET)
   }

   init = () => {
    this.elements.forEach((el) => {
      const button = el.querySelector('.dropdown__btn')
      const items = el.querySelectorAll('.dropdown__item')

      if(button){
        button.addEventListener('click', this.clickHandler, false)
      }

      items.forEach((item) => {
        item.addEventListener('click', this.clickItemHandler, false)
      })
   })
   }

   clickHandler = (e) => {
     const button = e.currentTarget
     const widget = button.closest(WIDGET)

     widget.classList.toggle(ACTIVECLASS)
   }

   clickItemHandler = (e) => {
    const el = e.currentTarget

    el.classList.add(ACTIVECLASS)
    this.closeActive()
   }

   closeActive = () => {
    const openDropdown = document.querySelector('.dropdown.is-open')

    if(openDropdown){
      openDropdown.classList.remove('is-open')
    }
   }
 }

 if(IS_COARSE){
  const DropdownObject = new Dropdown()
  DropdownObject.init()
}
